<template>
    <span>
        <editarocorrencia></editarocorrencia>
    </span>
</template>

<script>
import Editarocorrencia from '@/components/Editar-Ocorrencia';

export default {
    name: 'cadeditarocorrencia',
    components: {
        Editarocorrencia
    }
};
</script>